import React from "react";
import { Input, Select, DatePicker, Upload, Switch } from "antd";
import ModalWrapper from "../../Modal";
import { PlusOutlined } from "@ant-design/icons";

const EventModal = ({ open, onRequestClose }) => {
    return (
        <ModalWrapper title="Add Public Events" open={open} onRequestClose={onRequestClose}>
            <div className="flex flex-col gap-4 ">
                <div className="max-h-[60vh] overflow-y-auto px-2">
                    <div>
                        <Upload
                            listType="picture-card"
                            className="w-full mb-4"
                            maxCount={1}
                            beforeUpload={() => false}
                        >
                            <div>
                                <PlusOutlined />
                                <div style={{ marginTop: 8 }}>Upload File</div>
                            </div>
                        </Upload>
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block mb-1">Title*</label>
                            <Input placeholder="Enter title" />
                        </div>

                        <div>
                            <label className="block mb-1">Event Location*</label>
                            <Input placeholder="Event location" />
                        </div>

                        <div>
                            <label className="block mb-1">Event Date*</label>
                            <DatePicker className="w-full" />
                        </div>

                        <div>
                            <label className="block mb-1">Start Time*</label>
                            <Input placeholder="e.g. 06:00 PM" />
                        </div>

                        <div className="col-span-2">
                            <label className="block mb-1">Allow Comments</label>
                            <Switch />
                        </div>

                        <div className="col-span-2">
                            <label className="block mb-1">Description</label>
                            <Input.TextArea
                                placeholder="Write description..."
                                rows={4}
                            />
                        </div>

                        <div className="col-span-2">
                            <h3 className="font-medium mb-2">Event Access</h3>
                            <div className="grid grid-cols-4 gap-4">
                                <div>
                                    <label className="block mb-1">Location</label>
                                    <Select
                                        placeholder="College Road"
                                        className="w-full"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-1">Department</label>
                                    <Select
                                        placeholder="2 Checked"
                                        className="w-full"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-1">Designation</label>
                                    <Select
                                        placeholder="3 Checked"
                                        className="w-full"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-1">Employees</label>
                                    <Select
                                        placeholder="145 Checked"
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end gap-2 mt-4">
                    <button
                        className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300"
                        onClick={onRequestClose}
                    >
                        Cancel
                    </button>
                    <button className="px-4 py-2 rounded bg-blue-500 text-white hover:bg-blue-600">
                        Save
                    </button>
                </div>
            </div>
        </ModalWrapper>
    );
};

export default EventModal;